var _style, _g, _g2, _defs, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClrLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300.69 69.25",
    style: {
      enableBackground: "new 0 0 300.69 69.25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#172D6F;}\n\t.st2{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#172E70;}\n\t.st3{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#162F70;}\n\t.st4{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#152F70;}\n\t.st5{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#153071;}\n\t.st6{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#143171;}\n\t.st7{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#133272;}\n\t.st8{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#133372;}\n\t.st9{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#123372;}\n\t.st10{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#113473;}\n\t.st11{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#103573;}\n\t.st12{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#0F3673;}\n\t.st13{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#0E3674;}\n\t.st14{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#0D3774;}\n\t.st15{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#0D3874;}\n\t.st16{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#0C3875;}\n\t.st17{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#0B3975;}\n\t.st18{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#0A3975;}\n\t.st19{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#093A75;}\n\t.st20{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#093A76;}\n\t.st21{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#083A76;}\n\t.st22{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#073B76;}\n\t.st23{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#063B76;}\n\t.st24{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#063C77;}\n\t.st25{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#053C77;}\n\t.st26{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#043D77;}\n\t.st27{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#033D77;}\n\t.st28{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#023E78;}\n\t.st29{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#013E78;}\n\t.st30{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003F78;}\n\t.st31{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003F79;}\n\t.st32{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#004079;}\n\t.st33{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003F77;}\n\t.st34{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003E77;}\n\t.st35{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003E76;}\n\t.st36{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003D75;}\n\t.st37{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003C74;}\n\t.st38{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003C73;}\n\t.st39{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003B73;}\n\t.st40{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003B72;}\n\t.st41{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003A72;}\n\t.st42{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003A71;}\n\t.st43{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003970;}\n\t.st44{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003870;}\n\t.st45{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#00386F;}\n\t.st46{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#00376E;}\n\t.st47{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#00366D;}\n\t.st48{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#00366C;}\n\t.st49{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#00356C;}\n\t.st50{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#00356B;}\n\t.st51{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#00346A;}\n\t.st52{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003369;}\n\t.st53{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003268;}\n\t.st54{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003167;}\n\t.st55{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003066;}\n\t.st56{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003065;}\n\t.st57{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#002F65;}\n\t.st58{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#003166;}\n\t.st59{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#013167;}\n\t.st60{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#013268;}\n\t.st61{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#023268;}\n\t.st62{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#033369;}\n\t.st63{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#04346A;}\n\t.st64{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#05346A;}\n\t.st65{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#05356B;}\n\t.st66{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#06356C;}\n\t.st67{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#07356C;}\n\t.st68{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#07366D;}\n\t.st69{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#08366D;}\n\t.st70{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#09376E;}\n\t.st71{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#0A376F;}\n\t.st72{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#0B386F;}\n\t.st73{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#0B3870;}\n\t.st74{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#0C3970;}\n\t.st75{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#0D3971;}\n\t.st76{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#0D3A72;}\n\t.st77{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#0E3A72;}\n\t.st78{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#0F3B73;}\n\t.st79{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#103B73;}\n\t.st80{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#103C74;}\n\t.st81{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#113C74;}\n\t.st82{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#123D75;}\n\t.st83{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#123D76;}\n\t.st84{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#133E76;}\n\t.st85{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#143E77;}\n\t.st86{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#143F77;}\n\t.st87{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#153F78;}\n\t.st88{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#164079;}\n\t.st89{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#17417A;}\n\t.st90{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#18427B;}\n\t.st91{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#19427C;}\n\t.st92{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#19437C;}\n\t.st93{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#1A437D;}\n\t.st94{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#1A447D;}\n\t.st95{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#1B447E;}\n\t.st96{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#1C457F;}\n\t.st97{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#1D4680;}\n\t.st98{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#1D4681;}\n\t.st99{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#1E4781;}\n\t.st100{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#1E4782;}\n\t.st101{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#1F4882;}\n\t.st102{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#204883;}\n\t.st103{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#204984;}\n\t.st104{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#214984;}\n\t.st105{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#214A85;}\n\t.st106{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#224A85;}\n\t.st107{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#224B86;}\n\t.st108{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#234B87;}\n\t.st109{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#234C87;}\n\t.st110{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#244C88;}\n\t.st111{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#244D88;}\n\t.st112{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#254D89;}\n\t.st113{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#254D8A;}\n\t.st114{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#264E8A;}\n\t.st115{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#264E8B;}\n\t.st116{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#274F8B;}\n\t.st117{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#284F8C;}\n\t.st118{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#28508C;}\n\t.st119{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#29508D;}\n\t.st120{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#29518E;}\n\t.st121{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#2A518E;}\n\t.st122{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#2A528F;}\n\t.st123{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#2B528F;}\n\t.st124{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#2B5390;}\n\t.st125{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#2C5391;}\n\t.st126{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#2C5491;}\n\t.st127{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#2D5492;}\n\t.st128{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#2D5592;}\n\t.st129{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#2E5593;}\n\t.st130{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#2E5694;}\n\t.st131{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#2F5694;}\n\t.st132{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#2F5795;}\n\t.st133{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#305795;}\n\t.st134{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#305896;}\n\t.st135{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#315897;}\n\t.st136{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#315997;}\n\t.st137{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#325998;}\n\t.st138{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#325A98;}\n\t.st139{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#335A99;}\n\t.st140{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#335A9A;}\n\t.st141{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#345B9A;}\n\t.st142{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#345B9B;}\n\t.st143{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#355C9B;}\n\t.st144{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#355C9C;}\n\t.st145{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#365D9D;}\n\t.st146{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#375E9E;}\n\t.st147{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#385F9F;}\n\t.st148{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#385FA0;}\n\t.st149{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#3960A0;}\n\t.st150{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#3960A1;}\n\t.st151{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#3A61A1;}\n\t.st152{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#3A61A2;}\n\t.st153{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#3B62A3;}\n\t.st154{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#3C63A4;}\n\t.st155{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#3D64A5;}\n\t.st156{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#3E64A6;}\n\t.st157{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#3E65A6;}\n\t.st158{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#3F65A7;}\n\t.st159{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#3F66A8;}\n\t.st160{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#4066A8;}\n\t.st161{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#4067A9;}\n\t.st162{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#4167AA;}\n\t.st163{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#4168AA;}\n\t.st164{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#4269AB;}\n\t.st165{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#4369AC;}\n\t.st166{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#446AAE;}\n\t.st167{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#456BAD;}\n\t.st168{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#466BAC;}\n\t.st169{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#476BAC;}\n\t.st170{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#476BAB;}\n\t.st171{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#486CAB;}\n\t.st172{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#496CAB;}\n\t.st173{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#4A6CAA;}\n\t.st174{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#4B6DAA;}\n\t.st175{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#4C6DAA;}\n\t.st176{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#4D6DA9;}\n\t.st177{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#4E6EA9;}\n\t.st178{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#4F6EA8;}\n\t.st179{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#506EA8;}\n\t.st180{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#516FA8;}\n\t.st181{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#526FA8;}\n\t.st182{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#526FA7;}\n\t.st183{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#5370A7;}\n\t.st184{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#5470A7;}\n\t.st185{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#5570A7;}\n\t.st186{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#5571A6;}\n\t.st187{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#5671A6;}\n\t.st188{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#5771A6;}\n\t.st189{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#5871A5;}\n\t.st190{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#5972A5;}\n\t.st191{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#5A72A4;}\n\t.st192{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#5B73A4;}\n\t.st193{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#5C73A4;}\n\t.st194{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#5D74A3;}\n\t.st195{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#5E74A3;}\n\t.st196{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#5F74A3;}\n\t.st197{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#6075A2;}\n\t.st198{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#6175A2;}\n\t.st199{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#6275A2;}\n\t.st200{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#6276A1;}\n\t.st201{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#6376A1;}\n\t.st202{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#6476A1;}\n\t.st203{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#6477A1;}\n\t.st204{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#6577A0;}\n\t.st205{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#6677A0;}\n\t.st206{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#6778A0;}\n\t.st207{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#67789F;}\n\t.st208{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#68789F;}\n\t.st209{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#69799F;}\n\t.st210{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#6A799E;}\n\t.st211{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#6B7A9E;}\n\t.st212{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#6C7A9E;}\n\t.st213{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#6D7B9D;}\n\t.st214{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#6E7B9D;}\n\t.st215{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#6F7C9C;}\n\t.st216{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#707C9C;}\n\t.st217{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#717D9B;}\n\t.st218{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#727D9B;}\n\t.st219{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#737E9B;}\n\t.st220{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#747E9A;}\n\t.st221{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#757F9A;}\n\t.st222{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#767F99;}\n\t.st223{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#778099;}\n\t.st224{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#788099;}\n\t.st225{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#788098;}\n\t.st226{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#798198;}\n\t.st227{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#7A8198;}\n\t.st228{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#7A8197;}\n\t.st229{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#7B8297;}\n\t.st230{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#7C8297;}\n\t.st231{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#7C8296;}\n\t.st232{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#7D8396;}\n\t.st233{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#7E8396;}\n\t.st234{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#7E8395;}\n\t.st235{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#7F8495;}\n\t.st236{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#808495;}\n\t.st237{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#808594;}\n\t.st238{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#818594;}\n\t.st239{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#828693;}\n\t.st240{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#838693;}\n\t.st241{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#848792;}\n\t.st242{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#858792;}\n\t.st243{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#868891;}\n\t.st244{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#878891;}\n\t.st245{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#878991;}\n\t.st246{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#888990;}\n\t.st247{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#898990;}\n\t.st248{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#898A90;}\n\t.st249{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#8A8A8F;}\n\t.st250{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#8B8A8F;}\n\t.st251{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#8B8B8F;}\n\t.st252{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#8C8B8E;}\n\t.st253{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#8D8C8E;}\n\t.st254{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#8E8C8D;}\n\t.st255{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#8E8D8D;}\n\t.st256{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#8F8D8D;}\n\t.st257{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#908D8C;}\n\t.st258{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#908E8C;}\n\t.st259{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#918E8C;}\n\t.st260{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#928E8B;}\n\t.st261{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#928F8B;}\n\t.st262{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#938F8B;}\n\t.st263{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#94908A;}\n\t.st264{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#95908A;}\n\t.st265{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#969189;}\n\t.st266{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#979289;}\n\t.st267{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#989288;}\n\t.st268{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#999388;}\n\t.st269{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#9A9387;}\n\t.st270{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#9A9487;}\n\t.st271{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#9B9486;}\n\t.st272{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#9C9586;}\n\t.st273{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#9D9585;}\n\t.st274{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#9D9685;}\n\t.st275{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#9E9685;}\n\t.st276{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#9F9684;}\n\t.st277{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#9F9784;}\n\t.st278{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#A09784;}\n\t.st279{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#A19883;}\n\t.st280{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#A29883;}\n\t.st281{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#A39982;}\n\t.st282{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#A49A82;}\n\t.st283{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#A59A81;}\n\t.st284{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#A69A81;}\n\t.st285{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#A69B81;}\n\t.st286{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#A79B80;}\n\t.st287{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#A89C80;}\n\t.st288{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#A89C7F;}\n\t.st289{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#A99D7F;}\n\t.st290{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#AA9D7F;}\n\t.st291{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#AA9D7E;}\n\t.st292{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#AB9E7E;}\n\t.st293{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#AC9E7E;}\n\t.st294{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#AC9F7D;}\n\t.st295{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#AD9F7D;}\n\t.st296{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#AEA07C;}\n\t.st297{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#AFA07C;}\n\t.st298{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#B0A17B;}\n\t.st299{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#B1A17B;}\n\t.st300{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#B1A27A;}\n\t.st301{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#B2A27A;}\n\t.st302{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#B3A37A;}\n\t.st303{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#B3A379;}\n\t.st304{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#B4A479;}\n\t.st305{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#B5A478;}\n\t.st306{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#B6A578;}\n\t.st307{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#B7A577;}\n\t.st308{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#B8A677;}\n\t.st309{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#B8A676;}\n\t.st310{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#B9A776;}\n\t.st311{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#BAA775;}\n\t.st312{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#BAA875;}\n\t.st313{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#BBA875;}\n\t.st314{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#BCA974;}\n\t.st315{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#BDA973;}\n\t.st316{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#BEAA73;}\n\t.st317{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#BEAA72;}\n\t.st318{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#BFAB72;}\n\t.st319{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#C0AB71;}\n\t.st320{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#C1AC71;}\n\t.st321{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#C1AC70;}\n\t.st322{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#C2AD70;}\n\t.st323{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#C3AD6F;}\n\t.st324{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#C3AE6F;}\n\t.st325{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#C4AE6E;}\n\t.st326{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#C5AE6E;}\n\t.st327{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#C6AF6D;}\n\t.st328{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#C7B06C;}\n\t.st329{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#C8B06C;}\n\t.st330{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#C8B16B;}\n\t.st331{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#C9B16B;}\n\t.st332{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#CAB26A;}\n\t.st333{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#CBB369;}\n\t.st334{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#CCB368;}\n\t.st335{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#CCB468;}\n\t.st336{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#CDB467;}\n\t.st337{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#CEB467;}\n\t.st338{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#CFB566;}\n\t.st339{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#D0B665;}\n\t.st340{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#D1B665;}\n\t.st341{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#D1B764;}\n\t.st342{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#D2B763;}\n\t.st343{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#D3B863;}\n\t.st344{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#D3B862;}\n\t.st345{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#D4B962;}\n\t.st346{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#D5B961;}\n\t.st347{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#D6BA60;}\n\t.st348{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#D7BB5F;}\n\t.st349{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#D8BB5F;}\n\t.st350{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#D8BC5E;}\n\t.st351{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#D9BC5E;}\n\t.st352{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#DABD5D;}\n\t.st353{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#DBBD5C;}\n\t.st354{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#DBBE5C;}\n\t.st355{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#DCBE5B;}\n\t.st356{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#DDBF5B;}\n\t.st357{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#DDBF5A;}\n\t.st358{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#DEC059;}\n\t.st359{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#DFC059;}\n\t.st360{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#E0C158;}\n\t.st361{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#E1C257;}\n\t.st362{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#E2C257;}\n\t.st363{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#E3C356;}\n\t.st364{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#E3C355;}\n\t.st365{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#E4C455;}\n\t.st366{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#E5C454;}\n\t.st367{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#E5C554;}\n\t.st368{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#E6C553;}\n\t.st369{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#E7C653;}\n\t.st370{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#E7C652;}\n\t.st371{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#E8C752;}\n\t.st372{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#E9C751;}\n\t.st373{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#EAC850;}\n\t.st374{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#EBC94F;}\n\t.st375{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#ECC94F;}\n\t.st376{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#ECCA4E;}\n\t.st377{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#EDCA4D;}\n\t.st378{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#EECB4D;}\n\t.st379{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#EFCB4C;}\n\t.st380{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#EFCC4C;}\n\t.st381{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#F0CC4B;}\n\t.st382{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#F1CD4B;}\n\t.st383{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#F2CD4A;}\n\t.st384{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#F2CE4A;}\n\t.st385{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#F3CF49;}\n\t.st386{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#F4CF49;}\n\t.st387{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#F5D048;}\n\t.st388{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#F6D148;}\n\t.st389{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#F7D147;}\n\t.st390{clip-path:url(#SVGID_00000030473018563319305370000009607518732566651066_);fill:#F9D247;}\n\t.st391{fill:#0F0D09;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.15,33.27c-0.74,2.52-2.05,6.62-3,8.43c-1.47,0.38-5.94,1.48-9.67,1.48c-13.24,0-19.02-9.47-19.02-18.12 c0-11.5,8.46-19.1,20.39-19.1c4.26,0,7.88,1.2,9.3,1.48c0.42,3.07,0.79,5.36,1.1,8.38l-1.63,0.38 c-1.42-5.91-4.73-8.16-10.14-8.16c-8.57,0-13.14,7.66-13.14,15.93c0,10.18,5.62,17.13,13.51,17.13c5.2,0,8.04-3.01,10.72-8.43 L83.15,33.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.28,29.93c0,8.87-6.15,13.08-11.51,13.08c-7.41,0-11.67-6.08-11.67-12.1c0-9.03,6.73-13.19,11.72-13.19 C103.44,17.72,108.28,23.25,108.28,29.93z M90.46,29.11c0,6.9,2.68,12.04,6.88,12.04c3,0,5.57-2.3,5.57-9.91 c0-6.62-2.37-11.66-6.73-11.66C93.14,19.58,90.46,22.87,90.46,29.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M126.15,42.36v-1.48c2.94-0.33,3.31-0.71,3.31-4.54v-9.14c0-3.78-1.37-6.08-4.57-6.08c-1.94,0-3.89,1.26-5.41,2.63v12.92 c0,3.67,0.32,3.89,3.26,4.22v1.48h-11.61v-1.48c3.47-0.38,3.73-0.66,3.73-4.27V25.28c0-3.45-0.32-3.61-3.1-4.16V19.8 c2.63-0.49,5.26-1.2,7.73-2.24v4.32c1.05-0.77,2.15-1.64,3.47-2.52c1.52-1.04,2.79-1.64,4.31-1.64c4.2,0,6.78,3.07,6.78,8.38 v10.57c0,3.67,0.32,3.83,3.31,4.22v1.48H126.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.85,42.3c-0.89,0.49-1.68,0.71-2.15,0.71c-3.47,0-5.41-2.13-5.41-6.57V20.62h-3.57l-0.21-0.6l1.42-1.64h2.36v-4 l3.89-3.72l0.68,0.16v7.55h5.83c0.53,0.55,0.37,1.81-0.32,2.24h-5.52v13.96c0,4.38,1.79,5.15,3.1,5.15c1.21,0,2.36-0.44,3.1-0.82 l0.47,1.48L149.85,42.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M155.74,42.36v-1.48c3.26-0.33,3.63-0.66,3.63-4.38V25.28c0-3.45-0.21-3.67-3.21-4.16v-1.37 c2.73-0.44,5.41-1.15,7.83-2.08V36.5c0,3.72,0.32,4.05,3.68,4.38v1.48H155.74z M158.52,10.22c0-1.75,1.31-3.07,2.89-3.07 c1.52,0,2.79,1.31,2.79,3.07c0,1.59-1.26,2.96-2.84,2.96C159.84,13.18,158.52,11.81,158.52,10.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M185.01,42.36v-1.48c2.94-0.33,3.31-0.71,3.31-4.54v-9.14c0-3.78-1.37-6.08-4.57-6.08c-1.94,0-3.89,1.26-5.41,2.63v12.92 c0,3.67,0.32,3.89,3.26,4.22v1.48h-11.61v-1.48c3.47-0.38,3.73-0.66,3.73-4.27V25.28c0-3.45-0.32-3.61-3.1-4.16V19.8 c2.63-0.49,5.26-1.2,7.73-2.24v4.32c1.05-0.77,2.15-1.64,3.47-2.52c1.52-1.04,2.79-1.64,4.31-1.64c4.2,0,6.78,3.07,6.78,8.38 v10.57c0,3.67,0.32,3.83,3.31,4.22v1.48H185.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M218.17,37.59c-3.31,4.43-6.99,5.42-8.72,5.42c-6.57,0-10.35-5.47-10.35-11.66c0-3.83,1.37-7.23,3.52-9.63 c2.21-2.52,5.04-4,7.78-4c4.47,0,8.04,4.11,7.99,8.43c0,1.09-0.21,1.59-1.26,1.81c-0.84,0.11-7.41,0.66-13.51,0.88 c0.11,7.17,4.05,10.24,7.73,10.24c2.1,0,4.1-0.88,5.99-2.68L218.17,37.59z M203.93,26.53c2.79,0,5.52-0.05,8.41-0.16 c0.89,0,1.21-0.27,1.21-1.09c0.05-2.85-1.63-5.53-4.36-5.53C206.87,19.75,204.61,22.1,203.93,26.53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M236.2,42.36v-1.48c2.94-0.33,3.31-0.71,3.31-4.54v-9.14c0-3.78-1.37-6.08-4.57-6.08c-1.94,0-3.89,1.26-5.41,2.63v12.92 c0,3.67,0.32,3.89,3.26,4.22v1.48h-11.61v-1.48c3.47-0.38,3.73-0.66,3.73-4.27V25.28c0-3.45-0.32-3.61-3.1-4.16V19.8 c2.63-0.49,5.26-1.2,7.73-2.24v4.32c1.05-0.77,2.15-1.64,3.47-2.52c1.52-1.04,2.79-1.64,4.31-1.64c4.2,0,6.78,3.07,6.78,8.38 v10.57c0,3.67,0.32,3.83,3.31,4.22v1.48H236.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M259.9,42.3c-0.89,0.49-1.68,0.71-2.15,0.71c-3.47,0-5.41-2.13-5.41-6.57V20.62h-3.57l-0.21-0.6l1.42-1.64h2.36v-4 l3.89-3.72l0.68,0.16v7.55h5.83c0.53,0.55,0.37,1.81-0.32,2.24h-5.52v13.96c0,4.38,1.79,5.15,3.1,5.15c1.21,0,2.37-0.44,3.1-0.82 l0.47,1.48L259.9,42.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M282.61,43.01c-0.89,0-2-0.49-2.58-1.09c-0.68-0.71-1.05-1.48-1.26-2.35c-2.1,1.48-4.62,3.45-6.1,3.45 c-3.84,0-6.46-3.34-6.46-6.73c0-2.74,1.37-4.38,4.2-5.36c3.15-1.15,7.04-2.63,8.2-3.61v-1.09c0-3.83-1.68-6.02-4.2-6.02 c-0.95,0-1.73,0.38-2.26,1.04c-0.63,0.77-1.1,1.97-1.52,3.67c-0.26,0.99-0.84,1.37-1.68,1.37c-1,0-2.47-1.09-2.47-2.41 c0-0.88,0.68-1.48,1.73-2.3c1.52-1.15,5.05-3.23,8.04-3.83c1.63,0,3.26,0.49,4.41,1.48c1.94,1.64,2.47,3.89,2.47,6.84v9.96 c0,2.46,0.89,3.23,1.79,3.23c0.63,0,1.37-0.27,1.89-0.55l0.53,1.48L282.61,43.01z M278.61,29.22c-1.1,0.6-3.26,1.64-4.42,2.19 c-1.94,0.99-3.05,1.97-3.05,4c0,2.85,2.05,4.16,3.63,4.16c1.26,0,2.89-0.82,3.84-1.75V29.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M288.6,42.36v-1.48c3.31-0.38,3.73-0.66,3.73-4.27V10.82c0-3.61-0.32-3.78-3.57-4.11V5.4c2.79-0.33,6.2-1.26,8.15-1.92 v33.12c0,3.61,0.42,3.94,3.78,4.27v1.48H288.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.67,52.03h5.96c1.24,0,1.99,0.13,2.5,0.4c0.65,0.36,0.99,0.99,0.99,1.8c0,1.18-0.54,3.12-1.06,3.86 c-0.43,0.59-0.92,0.84-2.08,1.09l-0.02,0.09c1.15,0.07,1.71,0.59,1.71,1.56c0,0.25-0.02,0.41-0.11,0.79l-0.5,2.39h-2.8l0.4-1.87 c0.07-0.31,0.09-0.5,0.09-0.72c0-0.7-0.38-0.99-1.29-0.99h-2.78l-0.77,3.57h-2.76L56.67,52.03z M61.01,58.08 c0.95,0,1.42-0.25,1.71-0.93c0.16-0.34,0.41-1.54,0.41-1.89c0-0.66-0.31-0.86-1.35-0.86h-2.85l-0.79,3.68H61.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.15,56.93h5.33l-0.41,1.96h-5.33l-0.61,2.84h5.75l-0.48,2.28h-8.51l2.55-11.98h8.42l-0.49,2.28h-5.66L71.15,56.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.34,55.66c0.11-0.41,0.13-0.56,0.13-0.79c0-0.61-0.4-0.79-1.76-0.79c-1.36,0-1.85,0.13-2.17,0.52 c-0.25,0.32-0.43,0.9-0.43,1.4c0,0.39,0.16,0.57,0.56,0.7c0.23,0.05,0.23,0.05,2.15,0.18c1.88,0.11,2.51,0.25,3.05,0.65 c0.43,0.32,0.65,0.79,0.65,1.42c0,0.45-0.18,1.44-0.39,2.21c-0.41,1.4-0.97,2.08-2.05,2.53c-0.77,0.31-1.65,0.41-3.43,0.41 c-2.33,0-3.2-0.14-3.88-0.63c-0.38-0.27-0.63-0.86-0.63-1.45c0-0.5,0.05-0.9,0.25-1.85h2.64c-0.11,0.47-0.13,0.63-0.13,0.9 s0.13,0.54,0.31,0.65c0.29,0.18,0.48,0.2,1.99,0.2c1.01,0,1.2-0.02,1.54-0.18c0.38-0.16,0.56-0.41,0.74-0.93 c0.09-0.31,0.16-0.68,0.16-0.9c0-0.34-0.14-0.54-0.45-0.66c-0.23-0.07-0.23-0.07-2.1-0.2c-1.94-0.13-2.46-0.21-3.02-0.52 c-0.56-0.32-0.84-0.86-0.84-1.6c0-1.38,0.56-3.12,1.24-3.84c0.81-0.84,1.97-1.13,4.69-1.13c2.03,0,2.85,0.14,3.48,0.63 c0.36,0.27,0.59,0.86,0.59,1.45c0,0.5-0.05,0.86-0.23,1.63H86.34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100.94,52.36c0.99,0.47,1.45,1.27,1.45,2.53c0,1-0.75,4.72-1.2,5.92c-0.54,1.42-1.26,2.24-2.44,2.77 c-0.86,0.38-1.89,0.52-3.72,0.52c-1.8,0-2.57-0.13-3.29-0.5c-0.84-0.47-1.27-1.26-1.27-2.41c0-1.08,0.74-4.63,1.26-6.01 c0.52-1.4,1.22-2.15,2.48-2.73c0.86-0.38,1.8-0.5,3.74-0.5C99.54,51.94,100.31,52.05,100.94,52.36z M94.71,55.07 c-0.32,0.45-0.45,0.83-0.86,2.71c-0.36,1.63-0.47,2.28-0.47,2.71c0,1.06,0.36,1.24,2.42,1.24c1.9,0,2.39-0.34,2.89-2.08 c0.29-1.02,0.79-3.57,0.79-4.08c0-0.57-0.16-0.9-0.52-1.06c-0.32-0.16-0.68-0.2-1.78-0.2C95.64,54.31,95.16,54.46,94.71,55.07z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.02,52.03l-1.63,7.76c-0.23,1.06-0.57,2.06-0.88,2.51c-0.48,0.74-1.33,1.33-2.24,1.58c-0.54,0.14-1.49,0.21-2.8,0.21 c-1.87,0-2.6-0.09-3.34-0.41c-0.81-0.34-1.22-0.99-1.22-1.9c0-0.47,0.07-0.95,0.25-1.8l1.69-7.95h2.76l-1.69,7.95 c-0.05,0.22-0.11,0.7-0.11,0.88c0,0.65,0.52,0.86,2.14,0.86c1.96,0,2.3-0.25,2.66-1.87l1.65-7.83H116.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M119.1,52.03h5.96c1.24,0,1.99,0.13,2.5,0.4c0.65,0.36,0.99,0.99,0.99,1.8c0,1.18-0.54,3.12-1.06,3.86 c-0.43,0.59-0.92,0.84-2.08,1.09l-0.02,0.09c1.15,0.07,1.71,0.59,1.71,1.56c0,0.25-0.02,0.41-0.11,0.79l-0.5,2.39h-2.8l0.4-1.87 c0.07-0.31,0.09-0.5,0.09-0.72c0-0.7-0.38-0.99-1.29-0.99h-2.78l-0.77,3.57h-2.77L119.1,52.03z M123.45,58.08 c0.95,0,1.42-0.25,1.71-0.93c0.16-0.34,0.41-1.54,0.41-1.89c0-0.66-0.31-0.86-1.35-0.86h-2.86l-0.79,3.68H123.45z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140.18,59.61c-0.05,0.18-0.07,0.32-0.09,0.38c-0.47,2.15-0.88,2.85-2.03,3.5c-0.95,0.52-1.62,0.61-4.2,0.61 c-1.89,0-2.57-0.13-3.2-0.59c-0.61-0.45-0.97-1.26-0.97-2.23c0-0.61,0.43-3.16,0.83-4.78c0.5-2.19,1.13-3.16,2.44-3.9 c0.97-0.52,1.85-0.66,4.27-0.66c1.92,0,2.46,0.09,3.12,0.54c0.47,0.32,0.74,0.97,0.74,1.72c0,0.45-0.05,0.86-0.27,1.97h-2.75 c0.13-0.57,0.14-0.75,0.14-0.97c0-0.72-0.4-0.9-1.94-0.9c-1.71,0-2.3,0.29-2.64,1.29c-0.36,1.02-1.02,4.26-1.02,4.97 c0,0.88,0.48,1.15,2.07,1.15c2.05,0,2.41-0.27,2.75-2.12H140.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M145.96,56.93h5.33l-0.41,1.96h-5.33l-0.61,2.84h5.75l-0.49,2.28h-8.51l2.55-11.98h8.42l-0.49,2.28h-5.66L145.96,56.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M161.15,55.66c0.11-0.41,0.13-0.56,0.13-0.79c0-0.61-0.4-0.79-1.76-0.79c-1.36,0-1.85,0.13-2.17,0.52 c-0.25,0.32-0.43,0.9-0.43,1.4c0,0.39,0.16,0.57,0.56,0.7c0.23,0.05,0.23,0.05,2.15,0.18c1.88,0.11,2.51,0.25,3.05,0.65 c0.43,0.32,0.65,0.79,0.65,1.42c0,0.45-0.18,1.44-0.39,2.21c-0.41,1.4-0.97,2.08-2.05,2.53c-0.77,0.31-1.65,0.41-3.43,0.41 c-2.33,0-3.2-0.14-3.88-0.63c-0.38-0.27-0.63-0.86-0.63-1.45c0-0.5,0.05-0.9,0.25-1.85h2.64c-0.11,0.47-0.13,0.63-0.13,0.9 s0.13,0.54,0.31,0.65c0.29,0.18,0.48,0.2,1.99,0.2c1.01,0,1.2-0.02,1.54-0.18c0.38-0.16,0.56-0.41,0.74-0.93 c0.09-0.31,0.16-0.68,0.16-0.9c0-0.34-0.14-0.54-0.45-0.66c-0.23-0.07-0.23-0.07-2.1-0.2c-1.94-0.13-2.46-0.21-3.02-0.52 c-0.56-0.32-0.84-0.86-0.84-1.6c0-1.38,0.56-3.12,1.24-3.84c0.81-0.84,1.97-1.13,4.69-1.13c2.03,0,2.85,0.14,3.48,0.63 c0.36,0.27,0.59,0.86,0.59,1.45c0,0.5-0.05,0.86-0.23,1.63H161.15z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1.85,48.57c0.02,10.39,8.43,18.79,18.81,18.84c10.37-0.05,18.78-8.45,18.8-18.84 c0.02-13.13-17.16-31.28-18.8-48.39C19.01,17.28,1.82,35.44,1.85,48.57z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124141068872010583630000000475309326718113923_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39.46,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#172D6F"
    },
    width: 0.02,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.45,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#172D6F"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.44,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#172E70"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.43,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#162F70"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.42,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#152F70"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.41,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#153071"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#143171"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#133272"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.39,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#133372"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.38,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#123372"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.37,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#113473"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.36,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#103573"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.35,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#103573"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.34,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#0F3673"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.33,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#0E3674"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.32,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#0D3774"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.32,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#0D3874"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.31,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#0C3875"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.3,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#0B3975"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.29,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#0A3975"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.28,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#093A75"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.27,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#093A76"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.26,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#083A76"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.25,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#073B76"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.24,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#063B76"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.24,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#063C77"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.23,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#053C77"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.22,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#053C77"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.21,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#043D77"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.2,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#033D77"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.19,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#033D77"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.18,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#023E78"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.17,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#023E78"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.16,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#013E78"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.16,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#013E78"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.15,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003F78"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.14,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003F78"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.13,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003F78"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.12,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003F79"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.11,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003F79"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.1,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.09,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.08,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.08,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.07,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.06,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.05,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.04,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.03,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.02,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.01,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.99,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#004079"
    },
    width: 0.01,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.79,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#004079"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.59,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#004079"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.4,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003F78"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.2,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003F77"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.01,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003E77"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.81,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003E76"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.62,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003D75"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.42,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003D75"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.22,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003C74"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.03,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003C73"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.83,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003B73"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.64,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003B72"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.44,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003A72"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.24,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003A71"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.05,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003970"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.85,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003870"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.66,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#00386F"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.46,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#00376E"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.26,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#00376E"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.07,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#00366D"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.87,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#00366C"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.68,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#00356C"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.48,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#00356B"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.29,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#00346A"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.09,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#00346A"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.89,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003369"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003268"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003268"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.31,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003167"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.11,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003167"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.91,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003066"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.72,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003065"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.52,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#002F65"
    },
    width: 0.2,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.45,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#002F65"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.38,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003065"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.31,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003066"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.24,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#003166"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.17,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#013167"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#013268"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.03,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#023268"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.97,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#033369"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.9,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#033369"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.83,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#04346A"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.76,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#05346A"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.69,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#05356B"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.62,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#06356C"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.55,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#07356C"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.48,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#07366D"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.41,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#08366D"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.34,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#09376E"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.27,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#0A376F"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#0B386F"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.13,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#0B3870"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.06,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#0C3970"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.99,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#0D3971"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.92,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#0D3A72"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.85,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#0E3A72"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.78,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#0F3B73"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.71,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#103B73"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.64,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#103C74"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.57,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#113C74"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#123D75"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.43,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#123D76"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.36,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#133E76"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.29,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#143E77"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.22,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#143F77"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.15,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#153F78"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.08,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#164079"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.01,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#164079"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.94,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#17417A"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.87,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#17417A"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#18427B"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.73,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#19427C"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.66,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#19437C"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.59,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#1A437D"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.53,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#1A447D"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.46,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#1B447E"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.39,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#1C457F"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.32,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#1C457F"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.25,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#1D4680"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.18,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#1D4681"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.11,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#1E4781"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.04,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#1E4782"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.97,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#1F4882"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.9,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#204883"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.83,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#204984"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.76,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#214984"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.69,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#214A85"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.62,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#224A85"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.55,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#224B86"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.48,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#234B87"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.41,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#234C87"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.34,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#244C88"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.27,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#244D88"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#254D89"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.13,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#254D8A"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.06,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#264E8A"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.99,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#264E8B"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.92,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#274F8B"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.85,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#284F8C"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.78,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#28508C"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.71,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#29508D"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.64,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#29518E"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.57,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#2A518E"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#2A528F"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.43,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#2B528F"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.36,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#2B5390"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.29,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#2C5391"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.22,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#2C5491"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.15,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#2D5492"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.09,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#2D5592"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.02,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#2E5593"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.95,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#2E5694"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.88,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#2F5694"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.81,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#2F5795"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.74,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#305795"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.67,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#305896"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#315897"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.53,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#315997"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.46,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#325998"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.39,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#325A98"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.32,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#335A99"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.25,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#335A9A"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.18,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#345B9A"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.11,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#345B9B"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.04,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#355C9B"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.97,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#355C9C"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#365D9D"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.83,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#365D9D"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.76,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#375E9E"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.69,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#375E9E"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.62,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#385F9F"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.55,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#385FA0"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.48,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#3960A0"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.41,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#3960A1"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.34,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#3A61A1"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.27,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#3A61A2"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.2,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#3B62A3"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.13,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#3B62A3"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.06,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#3C63A4"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.99,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#3C63A4"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.92,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#3D64A5"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.85,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#3E64A6"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.78,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#3E65A6"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.71,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#3F65A7"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.65,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#3F66A8"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.58,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#4066A8"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.51,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#4067A9"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.44,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#4167AA"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.37,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#4168AA"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#4269AB"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.23,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#4369AC"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.16,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#446AAE"
    },
    width: 0.07,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.09,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#446AAE"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.03,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#456BAD"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.97,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#466BAC"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.9,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#476BAC"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.84,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#476BAB"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.78,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#486CAB"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.72,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#496CAB"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.65,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#4A6CAA"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.59,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#4B6DAA"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.53,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#4C6DAA"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.46,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#4D6DA9"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.4,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#4E6EA9"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.34,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#4E6EA9"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.27,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#4F6EA8"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.21,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#506EA8"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.15,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#516FA8"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.09,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#526FA8"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.02,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#526FA7"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.96,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5370A7"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5470A7"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.83,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5570A7"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.77,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5571A6"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.71,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5671A6"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.64,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5771A6"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.58,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5871A5"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.52,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5972A5"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.46,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5972A5"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.39,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5A72A4"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.33,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5B73A4"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.27,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5C73A4"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5C73A4"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.14,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5D74A3"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.08,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5E74A3"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.01,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5F74A3"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.95,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#5F74A3"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.89,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6075A2"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.82,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6175A2"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.76,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6275A2"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.7,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6276A1"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.64,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6376A1"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.57,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6476A1"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.51,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6477A1"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.45,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6577A0"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.38,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6677A0"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.32,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6778A0"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.26,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#67789F"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#68789F"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.13,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#69799F"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.07,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#69799F"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.01,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6A799E"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.94,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6B7A9E"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.88,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6B7A9E"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.82,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6C7A9E"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.75,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6D7B9D"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.69,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6D7B9D"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.63,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6E7B9D"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.56,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#6F7C9C"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#707C9C"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#707C9C"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.38,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#717D9B"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.31,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#727D9B"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.25,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#727D9B"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#737E9B"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.12,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#747E9A"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.06,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#747E9A"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#757F9A"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.93,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#767F99"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.87,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#767F99"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.81,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#778099"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.74,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#788099"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#788098"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.62,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#798198"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.56,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#7A8198"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.49,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#7A8197"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.43,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#7B8297"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.37,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#7C8297"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.3,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#7C8296"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.24,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#7D8396"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.18,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#7E8396"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.11,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#7E8395"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.05,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#7F8495"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.99,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#808495"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.93,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#808594"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.86,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#818594"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#818594"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.74,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#828693"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.67,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#838693"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.61,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#838693"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.55,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#848792"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.48,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#858792"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.42,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#858792"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.36,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#868891"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.29,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#878891"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.23,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#878991"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.17,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#888990"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.11,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#898990"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.04,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#898A90"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.98,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#8A8A8F"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.92,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#8B8A8F"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.85,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#8B8B8F"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.79,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#8C8B8E"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.73,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#8C8B8E"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.66,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#8D8C8E"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.6,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#8E8C8D"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.54,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#8E8D8D"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.48,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#8F8D8D"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.41,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#908D8C"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.35,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#908E8C"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.29,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#918E8C"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.22,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#928E8B"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.16,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#928F8B"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.1,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#938F8B"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.03,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#94908A"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.97,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#94908A"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.91,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#95908A"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.85,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#969189"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.78,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#969189"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.72,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#979289"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.66,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#989288"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.59,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#989288"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.53,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#999388"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.47,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#9A9387"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.4,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#9A9487"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.34,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#9B9486"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.28,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#9B9486"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.21,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#9C9586"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.15,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#9D9585"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.09,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#9D9685"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.03,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#9E9685"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.96,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#9F9684"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#9F9784"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.84,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#A09784"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.77,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#A19883"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.71,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#A19883"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.65,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#A29883"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.58,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#A39982"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.52,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#A39982"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.46,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#A49A82"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.4,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#A59A81"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.33,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#A69A81"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.27,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#A69B81"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.21,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#A79B80"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.14,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#A89C80"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.08,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#A89C7F"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.02,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#A99D7F"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.95,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#AA9D7F"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.89,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#AA9D7E"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.83,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#AB9E7E"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.77,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#AC9E7E"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.7,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#AC9F7D"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.64,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#AD9F7D"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.58,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#AEA07C"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.51,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#AFA07C"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.45,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#AFA07C"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.39,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#B0A17B"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.32,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#B1A17B"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.26,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#B1A27A"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.2,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#B2A27A"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.13,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#B3A37A"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.07,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#B3A379"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.01,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#B4A479"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.95,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#B5A478"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.88,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#B5A478"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.82,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#B6A578"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.76,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#B7A577"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.69,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#B8A677"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.63,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#B8A676"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.57,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#B9A776"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#BAA775"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.44,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#BAA875"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.38,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#BBA875"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.32,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#BCA974"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.25,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#BCA974"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.19,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#BDA973"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.13,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#BEAA73"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.06,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#BEAA72"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#BFAB72"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.94,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#C0AB71"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.87,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#C1AC71"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.81,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#C1AC70"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.75,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#C2AD70"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.68,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#C3AD6F"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.62,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#C3AE6F"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.56,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#C4AE6E"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#C5AE6E"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.43,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#C6AF6D"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.37,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#C6AF6D"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.31,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#C7B06C"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.24,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#C8B06C"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.18,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#C8B16B"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.12,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#C9B16B"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.05,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#CAB26A"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.99,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#CAB26A"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.93,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#CBB369"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.87,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#CCB368"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.8,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#CCB468"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.74,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#CDB467"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.68,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#CEB467"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.61,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#CFB566"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.55,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#CFB566"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.49,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#D0B665"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.42,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#D1B665"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.36,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#D1B764"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#D2B763"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.24,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#D3B863"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.17,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#D3B862"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.11,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#D4B962"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.05,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#D5B961"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.98,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#D6BA60"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.92,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#D6BA60"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.86,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#D7BB5F"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.79,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#D8BB5F"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.73,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#D8BC5E"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.67,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#D9BC5E"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#DABD5D"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.54,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#DBBD5C"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.48,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#DBBE5C"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.42,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#DCBE5B"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.35,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#DDBF5B"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.29,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#DDBF5A"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#DEC059"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.16,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#DFC059"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.1,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#E0C158"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.04,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#E0C158"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.97,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#E1C257"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.91,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#E2C257"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.85,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#E3C356"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.79,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#E3C355"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.72,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#E4C455"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.66,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#E5C454"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.6,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#E5C554"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.53,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#E6C553"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.47,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#E7C653"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.41,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#E7C652"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.34,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#E8C752"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.28,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#E9C751"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.22,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#EAC850"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.16,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#EAC850"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.09,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#EBC94F"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.03,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#ECC94F"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.97,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#ECCA4E"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.9,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#EDCA4D"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.84,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#EECB4D"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.78,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#EFCB4C"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.71,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#EFCC4C"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.65,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#F0CC4B"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.59,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#F1CD4B"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.52,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#F2CD4A"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.46,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#F2CE4A"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#F3CF49"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.34,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#F4CF49"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.27,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#F5D048"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.21,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#F6D148"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.15,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#F7D147"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.08,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#F9D247"
    },
    width: 0.06,
    height: 67.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.82,
    y: 0.18,
    style: {
      clipPath: "url(#SVGID_00000124141068872010583630000000475309326718113923_)",
      fill: "#F9D247"
    },
    width: 6.27,
    height: 67.23
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st391",
    d: "M20.66,69.25C9.29,69.2,0.03,59.92,0,48.57l0,0c-0.02-6.93,4.26-14.82,8.78-23.18 C13.32,17,18.02,8.32,18.82,0h3.68c0.8,8.32,5.49,17,10.03,25.4c4.52,8.36,8.79,16.25,8.78,23.17 C41.28,59.92,32.02,69.2,20.66,69.25z M20.65,8.76c-2.04,6.22-5.37,12.37-8.62,18.39c-4.29,7.93-8.35,15.43-8.34,21.42l0,0 c0.02,9.33,7.63,16.96,16.97,17c9.32-0.04,16.93-7.67,16.95-17c0.01-5.99-4.04-13.48-8.33-21.41 C26.02,21.13,22.69,14.98,20.65,8.76z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClrLoginLogo);
export default __webpack_public_path__ + "static/media/clr_login_logo.f2e4df30cdfb760ba23eddb0d2d8f2e9.svg";
export { ForwardRef as ReactComponent };